export default __webpack_public_path__ + "static/media/10.c3a084d5.svg";